import { render } from "./TargetSegmentEditor.vue?vue&type=template&id=ef71f010&ts=true"
import script from "./TargetSegmentEditor.vue?vue&type=script&lang=ts"
export * from "./TargetSegmentEditor.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__